export default __webpack_public_path__ + "static/media/auth-bg.f92f1acb.webp";